import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
  Validator,
} from "common";
import I18n from "i18n";
import { groupShift } from "./eventEditorApi";
import { useEventEditorContext } from "./EventEditorContext";

export function getMinutesOffset(item: ShiftGroupItem): number {
  return item.days * 24 * 60 + item.hours * 60 + item.minutes;
}

export type ShiftGroupItem = {
  days: number;
  hours: number;
  minutes: number;
};
export interface UseShiftGroupFormProps extends GridModalFormProps {}

export default function useShiftGroupForm({
  afterSave,
}: UseShiftGroupFormProps) {
  const {
    editMode,
    groupEditMode,
    selectedEvents,
    selectedEventGroups,
    resetSelection,
    selectSameEvents,
    selectSameGroups,
    selectEvent,
    viewMode,
    setViewMode,
    cal,
  } = useEventEditorContext();
  const form = useForm<ShiftGroupItem, ShiftGroupItem>({
    id: "create",
    ignoreNavigateAfterCreate: true,
    translationCategory: "EventEditor",
    rules: {
      days: Validator.rule.number().required(),
      hours: Validator.rule.number().required(),
      minutes: Validator.rule.number().required(),
    },
    afterSave,
    defaultValues: {
      days: 0,
      hours: 0,
      minutes: 0,
    },
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    createItem: async item => {
      const data = await groupShift({
        group_ids: selectedEventGroups,
        minutes_offset: getMinutesOffset(item),
      });
      if (data) {
        return { success: true };
      } else {
        return { success: false };
      }
    },
    loadOptions: undefined,
  });
  return { ...form };
}
